import { AbstractEditService } from '@/core/services/edit.service'
import { AbstractListService } from '@/core/services/list.service'
import { AbstractSearchService } from '@/core/services/search.service'
import { reactive } from 'vue'
import { aes } from '../apps/store'
import { URLPattenConfig } from '../apps/types'

class List extends AbstractListService<Store> {
  getFetchURL(): string {
    return 'template_rule/list'
  }
  getSearchParams(): any {
    return this.context.search.getSearchParams()
  }
}

class Edit extends AbstractEditService<Store> {
  getFetchURL(): string | boolean {
    return false
  }
  getDefaultFormData() {
    return {
      ruleName: '',
      url: '',
      labels: [],
      operation: [],
      showOrientationSwitch: false,
      orientation: 'portrait',
      contrast: 0,
      dpi: 300,
      showScaleSwitch: false,
      scale: 1,
      showPageTurner: false,
      openNewWindow: false,
      initScript: '',
      ratio_width: 3,
      ratio_height: 4,
      special_ua: ''
    } as URLPattenConfig
  }
  parseFetchedFormData(data: any) {
    return {
      ...data,
      initScript: aes.decode(data.initScript || '')
    } as URLPattenConfig
  }
  getRemoveURL(): string {
    return `template_rule/${this.params.id}`
  }
  getSubmitURL(): string {
    return this.isEdit ? `template_rule/${this.data.id}` : 'template_rule'
  }
  getSubmitData() {
    return {
      ...this.data,
      initScript: aes.encode(this.data.initScript)
    }
  }
  requestListReload(option?): void {
    this.context.list.fetch(option)
  }
}

class Search extends AbstractSearchService {
  onSubmit(): void {
    this.context.list.fetch({ reset: true })
  }
}

class Store {
  search: Search
  list: List
  edit: Edit
  constructor() {
    this.search = new Search(this)
    this.list = new List(this)
    this.edit = new Edit(this)
  }
}

export const store = reactive(new Store())
